<template>
    <v-container fluid>
        <category-form
            :category="model"
            :resellerTypes="resellerTypes"
            :titlePrefix="$t('forms.title_prefix.add')"
            @saved="saved"
        />
    </v-container>
</template>

<script>
import CategoryForm from './Form'
import Category from '@/models/Category'
import ResellerType from '@/models/ResellerType'

export default {
    components: {
        CategoryForm,
    },

    data: () => {
        return {
            model: new Category(),
            resellerTypes: [],
        }
    },

    created() {
        this.loadResellerTypes()
    },

    methods: {
        saved() {
            this.$router.go(-1)
        },

        async loadResellerTypes() {
            let res = await new ResellerType().all()
            this.resellerTypes = res.data
        },
    },
}
</script>

<style></style>
